import { joinUrl } from '@root/src/lib/joinUrl';
import { callApi } from '@root/src/web/lib/api';
const cache = {};
export const getIdApiUserData = (ajaxUrl) => {
    if (!(ajaxUrl in cache)) {
        const url = joinUrl([ajaxUrl, 'user/me']);
        const response = callApi(url, {
            credentials: 'include',
        });
        cache[ajaxUrl] = response;
    }
    return cache[ajaxUrl];
};
